import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Screens from '../../../screens';
import utils from '../../../utils';
import navigation from '../../../utils/navigation/navigation';
import routeParamConstants from '../../../utils/routeParamConstants';
import { Endpoints } from '../../../api/Constants';
import { AUTH_TYPES } from '../../../utils/authFlow/constants';
import { handleSignupErrorEvents } from '../../sagas/handleLoggerErrorEvents';
import { postLogin } from '../login';
import { addNotif } from '../../../state/actions/notification';
import gameVersion from '../../../utils/gameVersion';
export var postSignupMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.CREATE_USER),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, _ref) {
      var dispatch, queryFulfilled, _yield$queryFulfilled, data, success;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context.sent;
              data = _yield$queryFulfilled.data;
              success = _yield$queryFulfilled.data.success;
              if (success) dispatch(postLogin.initiate({
                email: args === null || args === void 0 ? void 0 : args.email,
                password: args === null || args === void 0 ? void 0 : args.password,
                login_type: AUTH_TYPES.STANDARD
              })).unwrap().then(function (result) {
                var _result$data, _result$data2;

                (result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.casino_id) && dispatch(addNotif({
                  timeout: -1,
                  message: "Thanks for signing up! *Your member ID is* {#41fff4}".concat(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.casino_id)
                }));
              }).catch(function (error) {
                throw error;
              });
              if (!success) handleSignupErrorEvents(data);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              handleSignupErrorEvents(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postSSOSignupMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.SSO_SIGNUP),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, _ref2) {
      var dispatch, queryFulfilled, _yield$queryFulfilled2, data, success, redirectionUrl;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled2 = _context2.sent;
              data = _yield$queryFulfilled2.data;
              success = _yield$queryFulfilled2.data.success;

              if (!success) {
                _context2.next = 11;
                break;
              }

              dispatch(postLogin.initiate({
                tokenValue: args === null || args === void 0 ? void 0 : args.ssoToken,
                tokenType: args === null || args === void 0 ? void 0 : args.SSOLoginTokenType.REFRESH_TOKEN
              })).unwrap().then(function (result) {
                var _result$data3, _result$data4;

                return (result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.casinoId) && dispatch(addNotif({
                  timeout: -1,
                  message: "Thanks for signing up! *Your member ID is* {#41fff4}".concat(result === null || result === void 0 ? void 0 : (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.casino_id)
                }));
              }).catch(function (error) {
                throw error;
              });
              _context2.next = 20;
              break;

            case 11:
              handleSignupErrorEvents(data, AUTH_TYPES.MEMBER);
              redirectionUrl = data.error_code === 'bbe3api_ssolog_2' && data.ssoAccountActivationRedirectionURL;

              if (!redirectionUrl) {
                _context2.next = 19;
                break;
              }

              if (!utils.isReactNative()) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("return", redirectionUrl);

            case 16:
              window.location = redirectionUrl;
              _context2.next = 20;
              break;

            case 19:
              navigation.navigate(Screens.Start, _defineProperty({}, routeParamConstants.PARAM_STATUS_MESSAGE, data.error));

            case 20:
              _context2.next = 25;
              break;

            case 22:
              _context2.prev = 22;
              _context2.t0 = _context2["catch"](1);
              handleSignupErrorEvents(_context2.t0, AUTH_TYPES.MEMBER);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 22]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};